/**
 *  Created by Rodrigo de Miguel for project Adopta-un-animal/AdoptaUnAnimal on 25/12/2022
 *
 */

function createPostalAddress(direccion) {
    let obj = {"@type": "PostalAddress"}
    if (direccion?.cod_postal) {
        obj.postalCode = direccion?.cod_postal
    }
    if (direccion?.calle) {
        obj.streetAddress = direccion?.calle
    }
    if (direccion?.municipio) {
        obj.addressLocality = direccion?.municipio
    }
    if (direccion?.pais) {
        obj.addressCountry = direccion?.pais
    }
    return obj
}

function createDescription(infoEntity) {
    let subtitle_tipo
    
    let tipoProtectoraTitle = "De la protectora "
    let tipoEntidad = infoEntity?.subtipo;
    if (tipoEntidad && ["Asociación", "Asociación CES"].includes(tipoEntidad)) {
        subtitle_tipo = "Asociación protectora de animales"
    } else if (tipoEntidad && ["Municipal"].includes(tipoEntidad)) {
        subtitle_tipo = "Protectora municipal de animales"
    } else if (tipoEntidad && ["Refugio", "Albergue"].includes(tipoEntidad)) {
        subtitle_tipo = tipoEntidad + " de animales"
    } else {
        subtitle_tipo = "Protectora de animales"
    }
    const descripcion = infoEntity.nombre + ", como " + subtitle_tipo + " ofrece hogar temporal a perros y gatos sin hogar en busca de una familia. Adopción de perros y gatos en la zona de " + ((infoEntity?.direccion?.municipio) ? (infoEntity?.direccion?.municipio) : (infoEntity.direccion && infoEntity?.direccion?.region) ? (infoEntity?.direccion?.region) : infoEntity?.direccion?.provincia) + " en " + (infoEntity?.direccion?.provincia) + " y reducir el abandono de animales. " +
        "Si quieres conocer más sobre " + infoEntity.nombre + " y cómo adoptar un perro o gato en su " + subtitle_tipo + " o cómo ayudar en su misión, ¡no dudes en ponerte en contacto con ellos!."
    
    return descripcion;
}

function createGeoCoordinates(direccion) {
    return {
        "@type": "GeoCoordinates",
        "latitude": direccion?.location?.coordinates[1],
        "longitude": direccion?.location?.coordinates[0]
    }
}

function createKeywordsProtectora(tags) {
    let arrayKeywords = []
    if (tags) {
        
        tags.forEach((tag) => {
            if (tag === "gatos" || tag === "perros" || tag === "caballos" || tag === "conejos") {
                arrayKeywords.push("adopción " + tag)
                arrayKeywords.push("rescate de " + tag)
                arrayKeywords.push("rescate de " + tag + " abandonados")
                arrayKeywords.push(tag + " abandonados")
            }
            if (tag === "colonias") {
                arrayKeywords.push("gestion " + tag + " felinas")
                arrayKeywords.push("gestion " + tag + " de gatos")
                arrayKeywords.push("cuidado de " + tag + " de gatos")
                arrayKeywords.push("cuidado de " + tag + " de felinas")
            }
            if (tag === "CES") {
                
                arrayKeywords.push("método " + tag)
                arrayKeywords.push("método " + tag + " gatos")
            }
            if (tag === "PPP") {
                arrayKeywords.push("adopción perros " + tag)
                arrayKeywords.push("rescate de perros " + tag)
                arrayKeywords.push("rescate de perros " + tag + " abandonados")
                arrayKeywords.push("perros " + tag + " abandonados")
            }
        })
    } else {
        arrayKeywords.push("adopción perros")
        arrayKeywords.push("adopción gatos")
        arrayKeywords.push("rescate de perros")
        arrayKeywords.push("rescate de gatos")
        arrayKeywords.push("rescate de perros abandonados")
        arrayKeywords.push("rescate de gatos abandonados")
    }
    
    return arrayKeywords.join(",")
}

export function createJSONSchemaProtectora(infoEntity, HOST, PATH_BUSCADOR_PETFRIENDLY_DETAIL_PERMALINK_PATTERN) {
    let srcImg_principal = infoEntity?.img_principal?.url
        ? infoEntity.img_principal.url
        : `${process.env.CDN_URL}/images/adoptaunanimal/default/'${infoEntity.tipo.toLowerCase()}.png`
        // : getImageEncode("default." + "protectora")
    return {
        "@context": "https://schema.org",
        "@type": "AnimalShelter",
        "@id": HOST + PATH_BUSCADOR_PETFRIENDLY_DETAIL_PERMALINK_PATTERN.replace(":tipo_entity", infoEntity.tipo).replace(":permalink", infoEntity.permalink),
        "url": HOST + PATH_BUSCADOR_PETFRIENDLY_DETAIL_PERMALINK_PATTERN.replace(":tipo_entity", infoEntity.tipo).replace(":permalink", infoEntity.permalink),
        "name": infoEntity.nombre,
        "legalName": infoEntity.nombre,
        "description": createDescription(infoEntity),
        "currenciesAccepted": "EUR",
        "paymentAccepted": "Cash",
        "openingHours": "Mo,Tu,We,Th,Fr,Su 10:00-19:30",
        "priceRange": "$",
        "logo": srcImg_principal,
        "image": [srcImg_principal].concat(infoEntity?.galeria_imagenes?.map(img=>img?.url)),
        "isAccessibleForFree": true,
        "keywords": createKeywordsProtectora(infoEntity.tags),
        "address": createPostalAddress(infoEntity.direccion),
        "location":
            {
                "@type": "Place",
                "address":
                    createPostalAddress(infoEntity.direccion),
                "name": infoEntity.nombre,
            },
        "foundingLocation":
            {
                "@type": "Place",
                "address": createPostalAddress(infoEntity.direccion),
                "name": infoEntity.nombre,
            },
        "areaServed":
            {
                "@type": "GeoCircle",
                "geoMidpoint": createGeoCoordinates(infoEntity.direccion),
                "geoRadius": 25000
            },
        "brand":
            {
                "@type": "Brand",
                "name": infoEntity.nombre,
            },
        
        "geo": createGeoCoordinates(),
        "openingHoursSpecification": [
            {
                "@type": "OpeningHoursSpecification",
                "opens": "10:00",
                "closes": "19:30",
                "dayOfWeek": ["lunes"]
            },
            {
                "@type": "OpeningHoursSpecification",
                "opens": "10:00",
                "closes": "19:30",
                "dayOfWeek": ["martes"]
            },
            {
                "@type": "OpeningHoursSpecification",
                "opens": "10:00",
                "closes": "19:30",
                "dayOfWeek": ["miércoles"]
            },
            {
                "@type": "OpeningHoursSpecification",
                "opens": "10:00",
                "closes": "19:30",
                "dayOfWeek": ["jueves"]
            },
            {
                "@type": "OpeningHoursSpecification",
                "opens": "10:00",
                "closes": "19:30",
                "dayOfWeek": ["viernes"]
            },
            {
                "@type": "OpeningHoursSpecification",
                "opens": "10:00",
                "closes": "14:00",
                "dayOfWeek": ["sábado"]
            },
            {
                "@type": "OpeningHoursSpecification",
                "opens": "00:00",
                "closes": "00:00",
                "dayOfWeek": ["domingo"]
            }],
        "aggregateRating":
            {
                "@type": "AggregateRating",
                "ratingValue": 9.2,
                "bestRating": 10,
                "worstRating": 0,
                "ratingCount": 15
            }
    }
}